import React, { Dispatch } from 'react'
import styled from 'styled-components'
import { Checkbox } from '../../atoms/Checkbox'
import { useHandleClickCheck } from './hooks'

type Props = {
  value: boolean
  setValue: Dispatch<React.SetStateAction<boolean>>
}

export const CheckboxBlock: React.FC<Props> = props => {
  const handleChangeCheck = useHandleClickCheck(props.setValue, props.value)

  return (
    <CheckBoxLine>
      <Checkbox checked={props.value} onChange={handleChangeCheck} />
      <CheckboxLabel onClick={handleChangeCheck}>
        導入相談を希望する
      </CheckboxLabel>
    </CheckBoxLine>
  )
}

const CheckBoxLine = styled.div`
  margin: 17px 0;
  height: 20px;
  display: flex;
  align-items: center;
`

const CheckboxLabel = styled.span`
  margin-left: 8px;
  color: #555;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.1px; /* 115% */
  cursor: pointer;
`
